import React from 'react';
import {twMerge} from "tailwind-merge";
import {IStateEnum} from "../models/enums/state.enum.ts";
import {useProject} from "../hooks/useProject.ts";
import {camelCaseToTitleCase} from "../utils/utils.ts";
import Tooltip from "./Tooltip.tsx";


interface ProjectTableStateColumnProps {
  state: IStateEnum;
  enableTooltip?: boolean;
}

const ProjectStateBadge: React.FC<ProjectTableStateColumnProps> = (
  {
    state,
    enableTooltip = true
  }: ProjectTableStateColumnProps) => {
  const {getStateTheme} = useProject()
  const {bgColor, hoverBgColor, textColor} = getStateTheme(state);

  const stateBadge = (
    <div className={twMerge(
      "flex items-center justify-center h-[30px] w-full rounded-full px-2",
      bgColor,
      hoverBgColor,
      textColor
    )}>
      <div className="text-sm font-normal">{camelCaseToTitleCase(state)}</div>
    </div>
  )

  if (!enableTooltip) {
    return stateBadge;
  }

  return (
    <Tooltip
      text="One or more processes failed"
      children={stateBadge}
      condition={state === IStateEnum.FAILED}
      arrowClassName="bg-transparent"
    />
  );
};

export default ProjectStateBadge;